import { useParams } from "react-router-dom";
import { PageContainer } from "../../../App/Components/PageContainer/PageContainer";
import { Grid, IconButton, Paper, Tooltip } from "@mui/material";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "../../../App/Typings/FeatureFlags";
import { ManageAccounts } from "@mui/icons-material";
import { useState } from "react";
import { useGetUserQuery } from "../../ABAC/AbacAppQueries";
import AdminUserDetailsForm from "./Components/AdminUserDetailsForm";
import { useModalHooks } from "../../../App/State/Hooks/useModalHooks";
import AttributeAssignmentComponent from "../../../App/Components/ABAC/AttributeAssignmentComponent";
import { ModalType } from "../../../App/Enums/ModalType";
import Modal from "../../../App/Components/Modals/Modal";
import { useAppSelector } from "../../../App/State/Store";
import { selectAdminState } from "../../../App/State/Slices/AdminSlice";

export default function AdminUserManagementPage() {
  const { id } = useParams<{ id: string }>();
  const { data: currentUser, isLoading } = useGetUserQuery(id);
  const { adminClient } = useAppSelector(selectAdminState);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { isModalTypeOpen } = useModalHooks();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  if (!enableAbacApplicationManagement) {
    return null;
  }

  if (isLoading) {
    return (
      <PageContainer>
        <p>Loading...</p>
      </PageContainer>
    );
  }

  if (!isLoading && currentUser) {
    const manageUserBreadcrumbs = [
      {
        breadCrumbName: "Cross Client Users",
        route: `adminUserManagement`,
      },
    ];

    return (
      <>
        <PageContainer>
          <Breadcrumb
            pageTitle={currentUser.firstName + " " + currentUser.lastName}
            customBreadcrumbs={manageUserBreadcrumbs}
          />
          <h1 className="admin-page-title">
            Manage {currentUser.firstName + " " + currentUser.lastName}
            <Tooltip title={"Admin Actions"}>
              <IconButton
                sx={{
                  ml: "2%",
                  border: "2px solid rgba(0,0,0,0.3)",
                }}
                onClick={handleClick}
              >
                <ManageAccounts />
              </IconButton>
            </Tooltip>
          </h1>
          <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
            <AdminUserDetailsForm
              currentUser={currentUser}
              menuAnchorElement={anchorEl}
              isMenuOpen={open}
              handleMenuClose={handleClose}
            />
          </Paper>

          <Modal
            fullWidth
            maxWidth="lg"
            open={isModalTypeOpen(ModalType.AttributeAssignment)}
            title={`Assign Permissions For ${adminClient.clientName}`}
            hasLoadingBar={true}
            isProcessing={false}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <AttributeAssignmentComponent clientId={adminClient.id} />
              </Grid>
            </Grid>
          </Modal>
        </PageContainer>
      </>
    );
  }
}
